import { format } from "date-fns";

export type FilterOption = { value: string; label: string };

export type DateRangeValue = { from?: Date; to?: Date };

export type FilterField =
  | { type: "dateRange"; key: string; label: string }
  | {
      type: "select";
      key: string;
      label: string;
      options?: FilterOption[];
      placeholder?: string;
      tagLabel?: string;
    };

export type FilterValues = Record<
  string,
  DateRangeValue | FilterOption | undefined
>;

const isOption = (value: unknown): value is FilterOption =>
  !!value && typeof value === "object" && "value" in value;

export const getOption = (values: FilterValues, key: string) => {
  const value = values[key];
  return isOption(value) ? value : undefined;
};

export const getDateRange = (values: FilterValues, key: string) => {
  const value = values[key];
  return value && !isOption(value) ? value : undefined;
};

export const isFilterActive = (value: FilterValues[string]) =>
  isOption(value) ? true : !!(value?.from || value?.to);

export const countActiveFilters = (values: FilterValues) =>
  Object.values(values).filter(isFilterActive).length;

const DATE_PARAM_FORMAT = "yyyy-MM-dd";

export const toDateRangeParams = (range?: DateRangeValue) => ({
  dateFrom: range?.from ? format(range.from, DATE_PARAM_FORMAT) : undefined,
  dateTo: range?.to ? format(range.to, DATE_PARAM_FORMAT) : undefined,
});
